import { BADGE_DEFS } from "../../constants/badges";

export function BadgesPanel({ userId, data }) {
  const earned = new Set((data.badges?.[userId] || []).map(b => b.id));
  return (
    <div className="card">
      <div className="card-title">Achievements</div>
      <div className="card-sub" style={{ marginBottom: "1rem" }}>{earned.size} of {BADGE_DEFS.length} badges earned</div>
      <div className="badges-grid">
        {BADGE_DEFS.map(b => (
          <div key={b.id} className={`badge-item ${earned.has(b.id) ? "earned" : "locked"}`} title={b.desc}>
            <div className="badge-icon">{b.icon}</div>
            <div className="badge-lbl">{b.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
